export  const featuredProduct = (product) => product.filter((eachProduct) => eachProduct.featured) 